<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-header-image image="images/q8-header.jpg" />
      <o-section-header title="Accountregistratie" />
      <o-section>
        <div class="u-flex">
          <o-text-input
            class="u-flex__flexible"
            label="Heb je al een Q8 smiles account?"
            :custom="true"
          >
            <o-radio name="account" ref="yesButton">Ja</o-radio>
            <o-radio name="account" ref="noButton">Nee</o-radio>
          </o-text-input>
          <o-icon icon="info" class="u-primary" />
        </div>
      </o-section>
    </o-view>
    <o-pay-button label="Volgende" @click="goToNext" />
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OHeaderImage,
    OPayButton
  },
  data() {
    return {}
  },
  methods: {
    goToNext() {
      if (this.$refs.yesButton.$refs.radio.checked) {
        this.$router.push('/sales/fuel/q8/onboarding/email-barcode')
      } else {
        this.$router.push('/sales/fuel/q8/onboarding/email')
      }
    }
  }
}
</script>

<style lang="scss"></style>
